import { render } from "./KeywordMix.vue?vue&type=template&id=c67468bc"
import script from "./KeywordMix.vue?vue&type=script&lang=js"
export * from "./KeywordMix.vue?vue&type=script&lang=js"

import "./KeywordMix.vue?vue&type=style&index=0&id=c67468bc&lang=css"

import exportComponent from "/data/projects/dev_private_futurelab/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__